import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";
import { LuxButton } from "@/components/lux";

const PROJECT_TYPES = ["Event", "Brand Campaign", "Corporate", "Government", "Commercial", "Product Launch", "Travel", "Recurring Content", "Wedding", "Other"];

export default function QuoteForm({ onDone }) {
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", project_type: "Event", budget: "", preferred_date: "", location: "", details: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.full_name || !form.email || !form.details) { toast.error("Please fill name, email and project details."); return; }
    setLoading(true);
    try {
      const res = await api.post("/quotes", form);
      toast.success("Quote request sent!");
      onDone?.(res.data.reference);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not submit. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit} className="rounded-2xl border border-white/10 bg-[#12141C] p-6 sm:p-8 space-y-5" data-testid="quote-form">
      <p className="text-[#94A3B8] text-sm">For events, campaigns, corporate & government work, product launches, travel photography and anything outside the standard packages.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Full Name" v={form.full_name} onChange={set("full_name")} testid="quote-name" />
        <Field label="Email" type="email" v={form.email} onChange={set("email")} testid="quote-email" />
        <Field label="Phone" v={form.phone} onChange={set("phone")} testid="quote-phone" />
        <div>
          <Label className="text-[#94A3B8] text-xs font-mono2">Project Type</Label>
          <div className="mt-2 flex flex-wrap gap-2">
            {PROJECT_TYPES.map((t) => (
              <button key={t} type="button" onClick={() => setForm({ ...form, project_type: t })}
                className={`text-xs font-mono2 px-3 py-1.5 rounded-full border ${form.project_type === t ? "bg-[#02AACF] border-[#02AACF] text-white" : "border-white/15 text-white/60"}`}>
                {t}
              </button>
            ))}
          </div>
        </div>
        <Field label="Budget (optional)" v={form.budget} onChange={set("budget")} testid="quote-budget" />
        <Field label="Preferred Date" v={form.preferred_date} onChange={set("preferred_date")} testid="quote-date" />
      </div>
      <Field label="Location" v={form.location} onChange={set("location")} testid="quote-location" />
      <div>
        <Label className="text-[#94A3B8] text-xs font-mono2">Project Details *</Label>
        <Textarea value={form.details} onChange={set("details")} rows={5} data-testid="quote-details"
          className="mt-2 bg-[#0b0d12] border-white/10 text-white focus-visible:ring-[#02AACF]" />
      </div>
      <LuxButton type="submit" disabled={loading} className="w-full" data-testid="quote-submit">
        {loading ? "Sending…" : "REQUEST CUSTOM QUOTE"}
      </LuxButton>
    </form>
  );
}

function Field({ label, v, onChange, type = "text", testid }) {
  return (
    <div>
      <Label className="text-[#94A3B8] text-xs font-mono2">{label}</Label>
      <Input type={type} value={v} onChange={onChange} data-testid={testid}
        className="mt-2 bg-[#0b0d12] border-white/10 text-white focus-visible:ring-[#02AACF]" />
    </div>
  );
}
